












































import { dateFormat } from '@/helpers/dateFormat';
import { parseStringToDate } from '@/helpers/dateUtils';
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    DatePicker
  }
})
export default class UiDatePickerSingle extends Vue {
  @Prop({
    default: ''
  })
  public label!: string;

  @Prop()
  public value!: any[];

  @Prop({
    default: null
  })
  public placeholder?: string;

  @Prop({
    default: ''
  })
  public height?: string;

  @Prop({
    default: false
  })
  public outline?: boolean;

  @Prop({
    default: false
  })
  public clearable?: boolean;
  @Prop({
    default: false
  })
  public loading?: boolean;
  @Prop({
    default: false
  })
  public disabled?: boolean;

  @Prop({
    default: null
  })
  public rules?: any;

  @Prop({
    default: null
  })
  public min?: string;

  private dateMenu: boolean = false;

  private dateFormatted: any = null;
  private date: string = null;

  private selectedDates: any = {};

  masksConfig = {
    title: 'MMMM "de" YYYY'
  };

  attrs = [
    {
      key: 'today',
      highlight: {
        fillMode: 'outline',
      },
      dates: new Date(),
    }
  ];

  @Watch('value')
  public onChangeValue(date): void {
    this.date = date;
    if (!date) {
      return;
    }
    this.dateFormatted = this.formatDate(date);

    this.dateMenu = false;

    this.prepareSelectedDates(this.date);
  }

  public beforeMount(): void {
    this.onChangeValue(this.value);
  }

  public onChangeDateFormatted(): void {
    this.date = null;
    if (this.dateFormatted == null || this.dateFormatted.length < 10) {
      this.dateFormatted = null;
      this.$emit('input', null);
      return;
    }
    this.date = dateFormat(this.dateFormatted, 'US', 'DD/MM/YYYY', true);
    this.prepareSelectedDates(this.date);
  }

  prepareSelectedDates(date) {
    this.selectedDates = parseStringToDate(date, 'YYYY-MM-DD')
  }

  public handleClear(): void {
    this.$emit('input', null);
  }

  public onChangeSeletedDate(): void {
    if (!this.selectedDates) {
      return;
    }

    // somente data
    this.selectedDates = new Date(this.selectedDates.toDateString());

    this.date = null;
    this.date = dateFormat(this.selectedDates, 'US', undefined, true);

    const calendar: any = this.$refs.calendar;
    calendar.move(this.selectedDates);

    this.$emit('input', this.date);
    this.$emit('change', this.date);
  }

  private formatDate(date: string): string {
    return !date ? '' : dateFormat(date, 'BR', undefined, true);
  }
}
